'use strict';
var ResultStyle;
(function (ResultStyle) {
    ResultStyle["Plain"] = "plain";
    ResultStyle["Card"] = "card";
})(ResultStyle || (ResultStyle = {}));
export default ResultStyle;
